import { createReducer } from '@reduxjs/toolkit'
import { setIdpInfo } from '../actions/EnsAction'
import { IdpInfo } from 'models'

const initialEns: IdpInfo = {
  ine10: '',
  ensActiu: '',
  urlEacat: '',
  urlCsv: '',
  organismes: [],
  organismesAutocomplete: [],
  nomIdp: '',
  nomEnsActiu: '',
  ensDisponibles: [],
  rol: '',
  nom: '',
  impersonated: false
}

const ensReducer = createReducer(initialEns, (builder) => {
  builder.addCase(setIdpInfo, (state, action) => {
    state.ensActiu = action.payload.ensActiu
    const ine10 = ('0000000000' + action.payload.ensActiu).slice(-10)
    state.ine10 = ine10
    state.urlEacat = action.payload.urlEacat
    state.urlCsv = action.payload.urlCsv
    state.ensDisponibles = action.payload.ensDisponibles
    state.nomIdp = action.payload.nom
    state.nomEnsActiu = action.payload.nomEnsActiu
    state.rol = action.payload.rol
    state.impersonated = action.payload.impersonated || false
  })
})

export default ensReducer
